var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"background"},[_c('HeaderDefault',{attrs:{"id":"home"}}),_c('MainDefault'),_c('FooterLinks')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }